import { ReactElement } from "react";
import {
  AddressFieldConfig,
  CountryFieldConfig,
  isAddressFieldWithMelissaConfig,
} from "@evergiving/common/dist/es2015/form";
import { FreeFormAddressComponent } from "@/lib/components/FreeFormAddressComponent";
import { useSelector } from "react-redux";
import { RootState } from "@/lib/redux/types";
import { AddressFieldWithMelissaSearch } from "./AddressFieldWithMelissaSearch";
import { AddressFieldWithLoqateSearch } from "./AddressFieldWithLoqateSearch";

export function AddressField({
  locale,
  countryFieldConfig,
  addressFieldConfig,
  defaultCountryCode,
}: {
  locale: string;
  countryFieldConfig: CountryFieldConfig | undefined;
  addressFieldConfig: AddressFieldConfig;
  defaultCountryCode: string;
}): ReactElement | null {
  const currentCountryCode = useSelector(
    (state: RootState) => state.countryCode.value
  );

  if ("melissa" in addressFieldConfig || "loqate" in addressFieldConfig) {
    return isAddressFieldWithMelissaConfig(addressFieldConfig) ? (
      <AddressFieldWithMelissaSearch
        locale={locale}
        countryFieldConfig={countryFieldConfig}
        addressFieldConfig={addressFieldConfig}
        defaultCountryCode={defaultCountryCode}
      />
    ) : (
      <AddressFieldWithLoqateSearch
        locale={locale}
        countryFieldConfig={countryFieldConfig}
        addressFieldConfig={addressFieldConfig}
        defaultCountryCode={defaultCountryCode}
      />
    );
  }

  return (
    <FreeFormAddressComponent
      cityCompletionEndpointUrl={
        addressFieldConfig.freeForm.cityCompletionEndpointUrl
      }
      currentCountryCode={currentCountryCode || defaultCountryCode}
      freeFormAddressFieldConfig={
        (currentCountryCode
          ? addressFieldConfig.freeForm.byCountry[currentCountryCode]
          : undefined) ?? addressFieldConfig.freeForm.defaultConfig
      }
    />
  );
}
